export const getCurrentReturnTo = () =>
  window.location.pathname + window.location.search + window.location.hash

export const redirectToClientLogin = (returnTo = getCurrentReturnTo()) => {
  window.location.href = `/api/client/login?redirect=${encodeURIComponent(returnTo)}`
}

export const redirectToClientLogout = (returnTo = '/') => {
  window.location.href = `/api/client/logout?redirect=${encodeURIComponent(returnTo)}`
}
